import * as React from 'react';

import Box from 'sail/Box';
import Grid, {GridItem} from 'sail/Grid';
import Group from 'sail/Group';
import {ContentGroupItem} from 'docs/util';
import {Heading, Text} from 'sail/Text';
import {DocsIcon, Link} from 'docs/components';
import {Tab} from '../Tabs/Tab';
import {TabGroup} from '../Tabs/TabGroup';

const PlaylistAboutTab = ({video}) => {
  const videoPresenters = video ? video.presenters : [];
  const videoResources = video ? video.resources : [];
  const videoRelatedDocs = video ? video.relatedDocs : [];

  return (
    <Tab>
      <Box margin={{top: 12, bottom: 24}} style={{width: '75%'}}>
        <Text size={16} lineHeight={24}>
          {video?.description}
        </Text>
      </Box>

      <Box flex={{alignItems: 'flex-end'}}>
        <Grid gap={20} style={{width: '100%'}}>
          <GridItem columnSpan={4}>
            <Heading color="gray600">Presenter</Heading>
            {videoPresenters &&
              videoPresenters.map((presenter) => {
                return (
                  <>
                    <Text
                      display="block"
                      align="left"
                      weight="bold"
                      size={24}
                      lineHeight={40}
                    >
                      {presenter.name}
                    </Text>
                    <Text
                      display="block"
                      align="left"
                      color="gray400"
                      size={14}
                    >
                      {presenter.title}
                    </Text>
                  </>
                );
              })}
          </GridItem>
          <GridItem columnSpan={4} column={5}>
            <Heading color="gray600">Related docs</Heading>
            {videoRelatedDocs &&
              videoRelatedDocs.map((doc) => {
                return (
                  <Group
                    direction="horizontal"
                    alignItems="center"
                    padding={{top: 12}}
                    spacing={8}
                  >
                    <DocsIcon category="general" icon="guide" size={16} />
                    <Link href={doc.url}>{doc.title}</Link>
                  </Group>
                );
              })}
          </GridItem>
          <GridItem columnSpan={4} column={9}>
            <Heading color="gray600">Resources</Heading>
            {videoResources &&
              videoResources.map((resource) => {
                return (
                  <Group
                    direction="horizontal"
                    alignItems="center"
                    padding={{top: 12}}
                    spacing={8}
                  >
                    <DocsIcon category="general" icon="github" size={16} />
                    <Link href={resource.url}>{resource.title}</Link>
                  </Group>
                );
              })}
          </GridItem>
        </Grid>
      </Box>
    </Tab>
  );
};

function PlaylistTabItems(video) {
  return [
    new ContentGroupItem(
      'about',
      'About',
      (<PlaylistAboutTab video={video} />),
    ),
    new ContentGroupItem(
      'transcripts',
      'Transcripts',
      (
        <Tab>
          CJ Avilla: (01:02) So if your app is written with a more feature rich
          web framework, like maybe BGo or something like that, the same
          fundamentals apply, but are implemented a little differently across a
          bigger, more opinionated code base such as that. It may be helpful to
          watch and refer to two other videos before watching this one. The
          first is about managing environment variables with Go. And the second
          is the introduction to the Stripe CLI. We’ll have links to these and
          other helpful resources in the description. As a quick agenda for
          today, we’ll cover how to set up a basic client with a static HTML
          file and Stripe.js installed. How to install your dependencies with
          Go. We’re going to use Go modules. How to implement a basic server .go
          file and add GET and POST routes. And also how to add a POST route for
          your webhook handler. CJ Avilla: (01:50) To start, we’ll create a
          client and server directory. The client will have a single HTML file,
          and the server will start with just server.go. So let’s jump right in
          and add some basic HTML in this index.HTML file. We’ll just add some
          rough structure and a little helper CSS file. In almost all Stripe
          samples or video tutorials for the web, we’re going to install
          Stripe.js. Note that you always want to load Stripe.js directly from
          js.stripe.com. Now in some cases, we’ll write front-end JavaScript
          directly in line to keep the content front and center. In other cases,
          we might use a script tag to include a JavaScript file from our
          project. We’ll need an instance of the Stripe object on the client in
          order to work with Stripe.js, which we can create by calling this
          constructor function and passing in our publishable key. You can find
          your publishable key in the Stripe dashboard. CJ Avilla: (02:40) It’s
          totally fine for purely web-based projects to hard-code your
          publishable key directly on the client. But if you’re working with
          mobile applications, it’s recommended that you fetch the publishable
          key from the server, so that versions of your mobile applications
          aren’t tied directly to a specific publishable key. So if you need to
          roll your key, you don’t have to ship new installs. So as an example
          of how to make a GET request to fetch some data from the server, we’ll
          make a request to receive the publishable key. And we’ll set it right
          here in just a bit. So let’s turn now to the backend. And in this
          episode, we’re going to use Go modules for managing our dependencies.
          So first, we need to run go mod init, and we’ll pass it just
          stripe.dev/samples as sort of our package here. So from now on, any
          time we run any of the built-in Go commands like build or install, or
          test, the Go tool chain will fetch and resolve dependencies
          automatically for us based on our import statements.
        </Tab>
      ),
    ),
  ];
}

export const PlaylistTabs = ({video}) => {
  return (
    <TabGroup
      items={PlaylistTabItems(video)}
      selector="tabs"
      pref={video.prefs}
    />
  );
};
